// src/App.js (or App.jsx)
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

// Layout
import Navbar from "../src/components/navbar/Navbar";
import Footer from "../src/components/footer/Footer";
import Loader from "../src/components/ui/Loader";

// Pages
import Main from "../src/components/pages/main/Main"; // Landing: Home + About + Contacts
import Products from "../src/components/pages/products/Products"; // Full page
import Projects from "../src/components/pages/projects/Projects"; // Full page

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    // Hide the splash once the window has loaded (with a short minimum so the
    // animation doesn't flash), then fall back to a timer on cached loads.
    const minDelay = setTimeout(() => setLoading(false), 1600);
    const onLoad = () => setLoading(false);
    if (document.readyState === "complete") {
      // already loaded — keep the brief splash via minDelay only
    } else {
      window.addEventListener("load", onLoad);
    }
    return () => {
      clearTimeout(minDelay);
      window.removeEventListener("load", onLoad);
    };
  }, []);

  return (
    <>
      <AnimatePresence>{loading && <Loader key="loader" />}</AnimatePresence>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/products" element={<Products />} />
        <Route path="/projects" element={<Projects />} />
        {/* Optional: 404 fallback */}
        {/* <Route path="*" element={<Main />} /> */}
      </Routes>
      <Footer />
    </>
  );
}
